import $ from 'jquery';
import Watcher from '../watcher';
import AutoplayVideo from '../video-autoplay';

// const DELAY = 0, STAGGER = 50;
// $('header h1 span').each((index, ele) => {
//     setTimeout(() => $(ele).addClass('show'), DELAY + index*STAGGER);
// });

// Intro Effekte triggern:
setTimeout(() => {
    $('#intro .emerge').addClass('emerge-show');
}, 100);

const watcher = new Watcher();
{
    const $images = $('section.new-scaling-layout .img-container');

    const SPEED = 1.2;
    const startWidth = 85; //%
    const startHeight = 85; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

                mask.style.width = `${width}%`;
                mask.style.height = `${height}%`;
            },
        });
    });
}

// Videos einfügen:
const $videos = $('.new-scaling-layout video');

$videos.each((i, ele) => {
    const $video = $(ele) as JQuery<HTMLVideoElement>;
    if (!$video.length) return;
    new AutoplayVideo($video);
});

$('section.new-scaling-layout .emerge.words').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            const visible = $(element).hasClass('emerge-show');
            if(!visible)
                setTimeout(() => $(element).addClass('emerge-show'));
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});
